import IconWrapper from '../wrapper/IconWrapper';

const GridIcon = ({ size = 24, color = null, className = null, title = "grid-icon" }) => {
    return (
        <IconWrapper size={size} color={color} className={className}>
            <svg fill="currentColor" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 72 72" enableBackground="new 0 0 72 72" xmlSpace="preserve">
                <g>
                    <g>
                        <path d="M34.5,27.568c0,3.828-3.104,6.932-6.932,6.932H10.432c-3.828,0-6.932-3.104-6.932-6.932V10.432
			C3.5,6.604,6.604,3.5,10.432,3.5h17.137c3.828,0,6.932,3.104,6.932,6.932V27.568z M30.5,10.432c0-1.619-1.313-2.932-2.932-2.932
			H10.432C8.813,7.5,7.5,8.813,7.5,10.432v17.137c0,1.619,1.313,2.932,2.932,2.932h17.137c1.619,0,2.932-1.313,2.932-2.932V10.432z"
                        />
                    </g>
                    <g>
                        <g>
                            <path d="M11.5,19.5c-0.553,0-1-0.447-1-1v-1.802c0-2.77,1.848-5.198,4.389-5.198h6.23c0.552,0,1,0.447,1,1s-0.448,1-1,1h-6.23
				c-1.56,0-2.389,1.72-2.389,3.198V18.5C12.5,19.053,12.052,19.5,11.5,19.5z"/>
                        </g>
                        <g>
                            <path d="M11.119,22.93c-0.261,0-0.521-0.11-0.71-0.29c-0.181-0.189-0.29-0.45-0.29-0.71s0.109-0.52,0.29-0.71
				c0.38-0.37,1.039-0.37,1.42,0c0.18,0.19,0.29,0.45,0.29,0.71s-0.11,0.521-0.29,0.7C11.639,22.819,11.379,22.93,11.119,22.93z"/>
                        </g>
                    </g>
                    <g>
                        <path d="M68.5,27.568c0,3.828-3.104,6.932-6.932,6.932H44.432c-3.828,0-6.932-3.104-6.932-6.932V10.432
			c0-3.828,3.104-6.932,6.932-6.932h17.137c3.828,0,6.932,3.104,6.932,6.932V27.568z M64.5,10.432c0-1.619-1.313-2.932-2.932-2.932
			H44.432c-1.619,0-2.932,1.313-2.932,2.932v17.137c0,1.619,1.313,2.932,2.932,2.932h17.137c1.619,0,2.932-1.313,2.932-2.932V10.432
			z"/>
                    </g>
                    <g>
                        <path d="M34.5,61.568c0,3.828-3.104,6.932-6.932,6.932H10.432c-3.828,0-6.932-3.104-6.932-6.932V44.432
			c0-3.828,3.104-6.932,6.932-6.932h17.137c3.828,0,6.932,3.104,6.932,6.932V61.568z M30.5,44.432c0-1.619-1.313-2.932-2.932-2.932
			H10.432c-1.619,0-2.932,1.313-2.932,2.932v17.137c0,1.619,1.313,2.932,2.932,2.932h17.137c1.619,0,2.932-1.313,2.932-2.932V44.432
			z"/>
                    </g>
                    <g>
                        <path d="M68.5,61.568c0,3.828-3.104,6.932-6.932,6.932H44.432c-3.828,0-6.932-3.104-6.932-6.932V44.432
			c0-3.828,3.104-6.932,6.932-6.932h17.137c3.828,0,6.932,3.104,6.932,6.932V61.568z M64.5,44.432c0-1.619-1.313-2.932-2.932-2.932
			H44.432c-1.619,0-2.932,1.313-2.932,2.932v17.137c0,1.619,1.313,2.932,2.932,2.932h17.137c1.619,0,2.932-1.313,2.932-2.932V44.432
			z"/>
                    </g>
                </g>
            </svg>
        </IconWrapper>
    );
}

export default GridIcon;